import styled from 'styled-components'
import { spacing, font } from '@chegg-ui/theme'
import { Button, IconButtonProps } from '@chegg-ui/button'

import {
  ModalContent as BaseModalContent,
  Container,
  CloseButton as BaseCloseButton,
} from '../styled'

export const ModalContent = styled(BaseModalContent)`
  padding: ${spacing.px32} 0px 0px 0px;
`

export const CloseButton = styled(BaseCloseButton)<IconButtonProps>`
  right: ${spacing.px12};
  top: ${spacing.px12};
  width: ${spacing.px32};
`

export const TitleIcon = styled.img`
  width: 200px;
`

export const TextContainer = styled.div`
  text-align: center;
  && {
    margin-top: 0px;
  }
`

export const TitleText = styled.h2`
  font-size: ${spacing.px32};
  font-weight: bold;
  margin: ${spacing.px16} 120px 0px;
`

export const SubTitleText = styled.h3`
  font-size: ${spacing.px16};
  margin: ${spacing.px16} 130px 0px;
  font-weight: ${font.weight.medium};
  line-height: 22px;
`

export const ContentContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: ${spacing.px32};
`

export const GetStartedButton = styled(Button)`
  padding: 10px ${spacing.px64};
`
